"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _index = _interopRequireDefault(require("@/components/fileImg/index.vue"));
var _banner = require("@/api/banner/banner");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      swiperInfo: {
        id: "",
        imageUrl: "",
        linkUrl: "",
        name: "",
        businessId: '',
        createBy: '',
        createTime: "",
        isDelete: '',
        remark: "",
        schoolId: '',
        sort: 0,
        updateBy: "",
        updateTime: ""
      },
      imageUrl: "",
      info: {}
    };
  },
  methods: {
    successUpLoad: function successUpLoad(e) {
      this.swiperInfo.imageUrl = e.ossOriUrl;
    },
    submit: function submit() {
      var _this = this;
      this.info = JSON.parse(sessionStorage.getItem("info"));
      (0, _banner.updateInfoBanner)({
        imageUrl: this.swiperInfo.imageUrl,
        linkUrl: this.swiperInfo.linkUrl,
        name: this.swiperInfo.name,
        businessId: this.info.businessId,
        isDelete: 0,
        schoolId: this.info.schoolId,
        sort: 0,
        id: this.swiperInfo.id
      }).then(function () {
        _this.$message.success("操作成功。");
        _this.$router.push("/webSet/swiperSchool/index");
      });
    },
    isBack: function isBack() {
      this.$router.push("/webSet/swiperSchool/index");
    }
  },
  created: function created() {
    this.swiperInfo = this.$route.query;
    console.log(this.swiperInfo, '99999');
  },
  components: {
    FileImg: _index.default
  }
};